const clusterIcon = `
    <svg data-qa="store-cluster-$[properties.geoObjects.length]" width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="44" height="44" rx="22" fill="white"/>
      <rect x="3" y="3" width="38" height="38" rx="19" fill="white"/>
      <text y="60%" fill="#333" font-size="17" font-weight="500">
        <tspan x="50%" text-anchor="middle">$[properties.geoObjects.length]</tspan>
      </text>
      <rect x="3" y="3" width="38" height="38" rx="19" stroke="#FDC300" stroke-width="2"/>
    </svg>
`;

const placemarkIcon = `
  <div
    data-qa="$[properties.dataQa]"
    style="transform: translate(-3px, -3px);"
  >
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="42" height="42" rx="21" fill="#FDC300"/>
    <rect x="1" y="1" width="42" height="42" rx="21" stroke="white" stroke-width="2"/>
    <path d="M31.5411 19.3906V31.3333H18.2422L19.3225 26.3698H25.758V21.7324L22.7558 18.7622L26.0746 13.9864L31.5411 19.3906ZM26.0746 13.9864L22.0001 18.0161L18.2422 21.7324V31.3333H12.4589V19.3906L21.9999 9.95834L26.0746 13.9864Z" fill="#21282B"/>
    </svg>
  </div>
`;

const placemarkIconActive = `
  <div
    data-qa="$[properties.dataQa]"
    style="
      position: relative;
      transform: translate(-5px, -5px);
    "
  >
    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="1" y="1" width="50" height="50" rx="25" fill="#21282B"/>
<rect x="1" y="1" width="50" height="50" rx="25" stroke="white" stroke-width="2"/>
<path d="M35.5411 23.3906V35.3333H22.2422L23.3225 30.3698H29.758V25.7324L26.7558 22.7622L30.0746 17.9864L35.5411 23.3906ZM30.0746 17.9864L26.0001 22.0161L22.2422 25.7324V35.3333H16.4589V23.3906L25.9999 13.9583L30.0746 17.9864Z" fill="#FDC300"/>
</svg>
    <div
      style="
        position: absolute;
        top: 9px;
        left: 58px;
        width: max-content;
        padding: 9px 16px;
        background: var(--background-primary);
        color: var(--text-primary);
        border-radius: 46px;
        box-shadow:
          0px 9px 33px rgba(0, 0, 0, 0.03),
          0px 2px 18px rgba(0, 0, 0, 0.04),
          0px 2px 10px rgba(0, 0, 0, 0.03),
          0px 1.4px 5px rgba(0, 0, 0, 0.03),
          0px 1.17px 2px rgba(0, 0, 0, 0.0196802);
        font: normal 500 12px/16px LMMain, sans-serif;
        letter-spacing: 0.2px;
      "
    >
      $[properties.balloonContent]
    </div>
  </div>
`;

const hoverLayout = `
  <div
    style="
    position: absolute;
    top: 2px;
    left: 50px;
    width: max-content;
    padding: 9px 16px;
    color: var(--text-primary);
    background: var(--background-primary);
    border-radius: 46px;
    box-shadow:
      0px 9px 33px rgba(0, 0, 0, 0.03),
      0px 2px 18px rgba(0, 0, 0, 0.04),
      0px 2px 10px rgba(0, 0, 0, 0.03),
      0px 1.4px 5px rgba(0, 0, 0, 0.03),
      0px 1.17px 2px rgba(0, 0, 0, 0.0196802);
    font: normal 500 12px/16px LMMain, sans-serif;
    letter-spacing: 0.2px;
    "
  >
    $[properties.balloonContent]
  </div>
`;

export { clusterIcon, placemarkIcon, placemarkIconActive, hoverLayout };
